import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB23KM_q30k1pAqbTqnIhZIgJk5OhPCOS4",
    authDomain: "travelmadeeasy-d11c4.firebaseapp.com",
    projectId: "travelmadeeasy-d11c4",
    storageBucket: "travelmadeeasy-d11c4.appspot.com",
    messagingSenderId: "8767542364",
    appId: "1:8767542364:web:5f3cd40aba73c29c4f8299",
    measurementId: "G-P3K7K6WSN6"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };
